import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import {
  CONSENT_CHANGE_EVENT,
  getConsent,
  setConsent,
} from "@/utils/consent";

const INTERNAL_PREFIXES = ["/admin", "/portal", "/content", "/login", "/logout"];

const CookieConsentBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const { user, loading } = useAuth();
  const location = useLocation();

  useEffect(() => {
    const evaluate = () => setVisible(getConsent() === undefined);
    evaluate();
    const onChange = () => evaluate();
    window.addEventListener(CONSENT_CHANGE_EVENT, onChange);
    return () => window.removeEventListener(CONSENT_CHANGE_EVENT, onChange);
  }, []);

  const isInternalRoute = INTERNAL_PREFIXES.some((p) =>
    location.pathname === p || location.pathname.startsWith(p + "/")
  );

  if (!visible) return null;
  if (loading) return null;
  if (user) return null;
  if (isInternalRoute) return null;

  const handle = (state: "granted" | "denied") => {
    setConsent(state);
    setVisible(false);
  };

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Aviso de cookies"
      className="fixed inset-x-0 bottom-0 z-[60] border-t border-border bg-background/95 backdrop-blur-sm shadow-lg"
    >
      <div className="container mx-auto max-w-6xl px-4 py-3 md:py-4 flex flex-col md:flex-row items-start md:items-center gap-3 md:gap-6">
        <p className="text-sm text-foreground/90 flex-1">
          Usamos cookies para analisar o tráfego e melhorar sua experiência. Você pode aceitar ou rejeitar cookies de análise e marketing.
        </p>
        <div className="flex gap-2 w-full md:w-auto">
          <Button
            variant="outline"
            size="sm"
            className="flex-1 md:flex-none"
            onClick={() => handle("denied")}
          >
            Rejeitar
          </Button>
          <Button
            size="sm"
            className="flex-1 md:flex-none"
            onClick={() => handle("granted")}
          >
            Aceitar
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
